import React, { createContext, useContext, useEffect, useState } from 'react';
import commonApi from '../utils/api';
import { useNavigate } from 'react-router-dom';
import { CommonContext } from './CommonContext';
import { format } from 'date-fns';
import { scrollToTop } from '../components/common/scrollToTop';

export const OrdersContext = createContext();

const initialFilters = {
    searchBy: 'awb_no',
    searchValue: '',
    merchant_id: [],
    status: '',
    courier_id: [],
    delivery_type_id: '',
    order_status_id: [24],
    dateRange: {
        startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
        endDate: new Date()
    },
    tab_id: 24,
};
const tabOptions = [
    { label: "Not Shipped", value: 24 },
    { label: "Today Uploads", value: 1 },
    { label: "Manifest", value: 2 },
    { label: "NDR", value: 9 },
    { label: "In Transit", value: 5 },
    { label: "Delivered", value: 8 },
    { label: "OFD", value: 7 },
    { label: "Returned to Seller", value: 12 },
    { label: "Booking Failed", value: 21 },
    { label: "All Shipped Orders", value: 99 }
];
export const OrdersContextProvider = ({ children }) => {
    const { user, setAlertMessage, setOpenAlert, setSeverity, globalSearch, modalAlert, setModalAlert } = useContext(CommonContext);
    const navigate = useNavigate();

    const getInitialState = () => {
        const redirectFilters = localStorage.getItem('redirectFilters');
        if (redirectFilters) {
            const parsed = JSON.parse(redirectFilters);
            return {
                filters: { ...initialFilters, ...parsed },
                activeTab: parsed.tab_id
            };
        }
        return { filters: initialFilters, activeTab: tabOptions[0].value };
    };

    const initialState = getInitialState();
    const [filters, setFilters] = useState(initialState.filters);
    const [activeTab, setActiveTab] = useState(initialState.activeTab);
    const [addModal, setAddModal] = useState(false);
    const [osId, setOsId] = useState(1);
    const [isExportOpen, setIsExportOpen] = useState(false);
    const [selected, setSelected] = useState([]);
    const [allData, setAllData] = useState([]);
    const [allOrders, setAllOrders] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [statusModal, setStatusModal] = useState(false);
    const [awbMerchantModal, setAwbMerchantModal] = useState(false);
    const [cancelDialog, setCancelDialog] = useState(false);
    const [cancelRemarks, setCancelRemarks] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [details, setDetails] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [openTracking, setOpenTracking] = useState(false);
    const [orderDate, setOrderDate] = useState(null);
    const [trackingInfo, setTrackingInfo] = useState(null);
    const [recordingList, setRecordingList] = useState([]);
    const [recordingurl, setRecordingurl] = useState(null);
    const [isRecordingModalOpen, setIsRecordingModalOpen] = useState(false);
    const [openShipModal, setOpenShipModal] = useState(false);
    const [shippingData, setShippingData] = useState([]);

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setAddModal(false);
    };

    const handleStatusModal = () => {
        setStatusModal(true);
    };

    const handleCloseStatusModal = () => {
        setStatusModal(false);
    };

    const handleAwbMerchantModal = () => {
        setAwbMerchantModal(true);
    };

    const handleCloseAwbMerchantModal = () => {
        setAwbMerchantModal(false);
    };

    const handleCloseShipModal = () => {
        setOpenShipModal(false);
        setShippingData([]);
    };

    const handleToggleDrawer = () => {
        setIsOpen(!isOpen);
    };
    // console.log('filters', filters);
    const onLoadApi = (customFilters = filters) => {
        // debugger;
        const payload = {
            ...customFilters,
            start_date: customFilters?.dateRange?.startDate
                ? format(new Date(customFilters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: customFilters?.dateRange?.endDate
                ? format(new Date(customFilters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (activeTab === 99 && (!customFilters?.order_status_id || customFilters?.order_status_id?.length === 0)) {
            payload.order_status_id = [];
        }

        // if (globalSearch?.value) {
        //     payload.searchBy = 'awb_no';
        //     payload.searchValue = globalSearch?.value;
        //     payload.start_date = '';
        //     payload.end_date = '';
        //     setFilters((prev) => ({ ...prev, order_status_id: [99], tab_id: 99, searchBy: 'awb_no', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
        //     setActiveTab(99);
        // }
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = [user?.id]
        }
        delete payload.dateRange;
        setAllData([]);
        setAllOrders([]);
        setFirstLoading(false);
        commonApi.post(`/orders/list?page=${page + 1}&per_page=${rowsPerPage}`, payload)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllOrders(response?.data?.data);
                    setAllData(response?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onTracking = (order) => {
        setOpenTracking(false);
        setTrackingInfo(null);
        setCurrentTrackingOrder(order);
        setIsLoading(true);
        commonApi.post('/orders/tracking', { order_ids: order.id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setOpenTracking(true);
                    setTrackingInfo(response?.data?.data)
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                    setOpenAlert(true);
                    scrollToTop();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error');
                setOpenAlert(true);
                scrollToTop();
            });
    }
    const viewDetail = (id) => {
        setDetails(null);
        setIsLoading(true);
        commonApi.post('/orders/view', { id: id })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setDetails(response?.data?.data);
                    handleToggleDrawer();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    }
    // Fetch initial data when the context is created
    useEffect(() => {
        localStorage.removeItem('redirectFilters');
    }, []);

    useEffect(() => {
        const customFilters = { ...filters };
        if (globalSearch?.value) {
            customFilters.searchBy = 'awb_no';
            customFilters.searchValue = globalSearch?.value;
            customFilters.start_date = '';
            customFilters.end_date = '';
            customFilters.order_status_id = [];
            customFilters.tab_id = 99;
            customFilters.dateRange = { startDate: null, endDate: null };
            setFilters((prev) => ({ ...prev, order_status_id: [99], tab_id: 99, searchBy: 'awb_no', searchValue: globalSearch?.value, dateRange: { startDate: null, endDate: null } }));
            setActiveTab(99);
        }
        onLoadApi(customFilters);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, rowsPerPage, activeTab, globalSearch?.searchTrigger]);

    const onCancelOrder = () => {
        setIsLoading(true);
        commonApi.post('/orders/cancel-orders', { "order_ids": selected.join(', '), "remarks": cancelRemarks })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setCancelRemarks('');
                    setSelected([]);
                    setCancelDialog(false);
                    onLoadApi();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error.response?.data?.msg);
                setSeverity('error')
                console.error('Error fetching data:', error);
            });
    };
    const recheckStatus = () => {
        setIsLoading(true);
        commonApi.post('/cron/tracking', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setCancelRemarks('');
                    setSelected([]);
                    setCancelDialog(false);
                    onLoadApi();
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error.response?.data?.msg);
                setSeverity('error')
                console.error('Error fetching data:', error);
            });
    };
    const onLabelGen = (id = null) => {
        console.log('id', id, selected);
        setIsLoading(true);
        commonApi.post('/orders/generate-address-labels', { "order_ids": id ? id : selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onBulkPOD = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-bulk-pod', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setAlertMessage(error?.response?.data?.msg || error?.message || 'Something went wrong');
                setOpenAlert(true);
                setSeverity('error');
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onInvoiceGen = (id = null) => {
        setIsLoading(true);
        commonApi.post('/orders/generate-product-invoices', { "order_ids": id ? id : selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onManifestGen = () => {
        setIsLoading(true);
        commonApi.post('/orders/generate-manifest', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const downLoadPod = (id) => {
        setIsLoading(true);
        commonApi.post('/orders/generate-epod', { "order_ids": id })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    // setSelected([]);
                    // onLoadApi();
                    setTimeout(() => {
                        navigate('/download');
                    }, 3000);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    };
    const onShip = () => {
        setIsLoading(true);
        commonApi.post('/orders/ship', { "order_ids": selected.join(', ') })
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setSelected([]);
                    onLoadApi();
                    setShippingData(response?.data?.allREsponse || []);
                    setOpenShipModal(true);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error')
            });
    };
    const onExport = (columns) => {
        const isOtherFilterActive =
            filters?.searchValue ||
            (filters?.merchant_id && filters.merchant_id.length > 0) ||
            (filters?.courier_id && filters.courier_id.length > 0) ||
            filters?.status ||
            filters?.delivery_type_id ||
            (filters?.order_status_id && filters.order_status_id.length > 0 && filters.order_status_id?.[0] !== initialFilters.order_status_id?.[0]);

        if (selected.length === 0) {
            if (!isOtherFilterActive && (!filters?.dateRange?.startDate || !filters?.dateRange?.endDate)) {
                setAlertMessage('Date range is mandatory for export');
                setSeverity('error');
                setOpenAlert(true);
                setIsExportOpen(false);
                scrollToTop();
                return;
            }

            if (filters?.dateRange?.startDate && filters?.dateRange?.endDate) {
                const start = new Date(filters.dateRange.startDate);
                const end = new Date(filters.dateRange.endDate);
                const maxDate = new Date(start);
                maxDate.setMonth(maxDate.getMonth() + 3);

                if (end > maxDate) {
                    setAlertMessage('Maximum date range for export is 3 months');
                    setSeverity('error');
                    setOpenAlert(true);
                    setIsExportOpen(false);
                    scrollToTop();
                    return;
                }
            }
        }

        let payload = {
            ...filters,
            start_date: filters?.dateRange?.startDate
                ? format(new Date(filters.dateRange.startDate), 'yyyy-MM-dd')
                : null,
            end_date: filters?.dateRange?.endDate
                ? format(new Date(filters.dateRange.endDate), 'yyyy-MM-dd')
                : null,
        };
        if (user?.user_type !== "Merchant") {
            payload.admin_id = user?.id
        } else {
            payload.merchant_id = [user?.id]
        }
        if (selected.length > 0) {
            payload.order_ids = selected.join(', ')
        }
        if (columns?.length) payload.columns = columns

        delete payload.dateRange;
        setIsLoading(true);
        commonApi.post('/orders/export', payload)
            .then((response) => {
                setIsLoading(false);
                setOpenAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error')
                } else {
                    navigate('/download');
                    setIsExportOpen(false);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.response?.data?.msg);
                setSeverity('error')
            });
    };

    const onRecording = (row) => {
        setIsLoading(true);
        commonApi.post('/ivr/list-recordings', { 'order_id': row?.id, 'customer_mobile': row?.customer_mobile, 'awb_no': row?.awb_no })
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    const combinedData = Array.isArray(response?.data?.data)
                        ? response.data.data.map(item => ({
                            ...item,
                            awb_no: row?.awb_no,
                            order_no: row?.order_no,
                        }))
                        : { ...response?.data?.data, awb_no: row?.awb_no, order_no: row?.order_no, };

                    setRecordingList(Array.isArray(combinedData) ? combinedData : [combinedData]);
                    setRecordingurl(response?.data?.recording_base_url);
                    setIsRecordingModalOpen(true);
                } else {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg || 'No recordings found');
                    setSeverity('error');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
                setOpenAlert(true);
                setAlertMessage(error?.response?.data?.msg || 'Error fetching recordings');
                setSeverity('error');
            });
    };

    const closeRecordingModal = () => {
        setIsRecordingModalOpen(false);
        setRecordingList([]);
    };

    const onCalling = (row) => {
        setIsLoading(true);
        const postReq = { order_id: row.id ?? '', awb_no: row.awb_no ?? '', customer_mobile: row.customer_mobile ?? '', ivr_mobile: user?.ivr_mobile ?? '' }
        commonApi.post('ivr/clickToCall', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                } else {
                    setOpenAlert(true);
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setOpenAlert(true);
                setAlertMessage(error?.res?.data?.msg);
                setSeverity('error');
            });
    };

    const [currentTrackingOrder, setCurrentTrackingOrder] = useState(null);

    const [ndrModal, setNdrModal] = useState(false);

    const handleNdrModal = () => {
        setNdrModal(true);
    };

    const handleCloseNdrModal = () => {
        setNdrModal(false);
        setModalAlert(false);
    };

    const onMoveToNDR = (formDataTemp) => {
        setIsLoading(true);
        const payload = {
            ...formDataTemp,
            order_id: selected,
            courier_attempt_date: formDataTemp.courier_attempt_date ? format(new Date(formDataTemp.courier_attempt_date), 'yyyy-MM-dd') : null,
        };

        commonApi.post('/ndr/create-ndr', payload)
            .then((response) => {
                setIsLoading(false);
                setModalAlert(true);
                if (response?.data?.s === 0) {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('error');
                } else {
                    setAlertMessage(response?.data?.msg);
                    setSeverity('success');
                    setTimeout(() => {
                        handleCloseNdrModal();
                        setSelected([]);
                        onLoadApi();
                    }, 1500);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setModalAlert(true);
                setAlertMessage(error.response?.data?.msg || error?.message || 'Something went wrong');
                setSeverity('error');
                console.error('Error moving to NDR:', error);
            });
    };

    const contextValue = {
        cancelRemarks,
        setCancelRemarks,
        onCalling,
        addModal,
        handleAddModal,
        handleCloseModal,
        statusModal,
        handleStatusModal,
        handleCloseStatusModal,
        trackingInfo,
        currentTrackingOrder,
        openTracking,
        setOpenTracking,
        onTracking,
        orderDate,
        setOrderDate,
        isOpen,
        setIsOpen,
        handleToggleDrawer,
        viewDetail,
        details,
        initialFilters,
        osId,
        setOsId,
        allData,
        setAllData,
        allOrders,
        setAllOrders,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        firstLoading,
        setFirstLoading,
        cancelDialog,
        setCancelDialog,
        isLoading,
        setIsLoading,
        onLoadApi,
        selected,
        setSelected,
        tabOptions,
        activeTab,
        setActiveTab,
        filters,
        setFilters,
        onCancelOrder,
        onExport,
        isExportOpen,
        setIsExportOpen,
        recheckStatus,
        downLoadPod,
        onManifestGen,
        onInvoiceGen,
        onLabelGen,
        onBulkPOD,
        onShip,
        onRecording,
        recordingList,
        recordingurl,
        isRecordingModalOpen,
        closeRecordingModal,
        openShipModal,
        setOpenShipModal,
        shippingData,
        setShippingData,
        handleCloseShipModal,
        awbMerchantModal,
        handleAwbMerchantModal,
        handleCloseAwbMerchantModal,
        ndrModal,
        handleNdrModal,
        handleCloseNdrModal,
        onMoveToNDR,
    };
    return (
        <OrdersContext.Provider value={contextValue}>
            {children}
        </OrdersContext.Provider>
    );
};

